import { defineMessages } from 'react-intl';
export default defineMessages({
  collectionDeleted: {
    id: 'component.collectionRow.collectionDeleted',
    defaultMessage: 'Collection deleted',
  },
});
